import { ref, computed, reactive } from 'vue'
import { defineStore } from 'pinia'
import { type CartItemResponse, fetchCartItem, getCart } from "@/api/frontend.ts";

export const useCartStore = defineStore('cart', () => {
  /* Cart */

  const cart = reactive<{
    currency: string, //default
    discounts: any[],
    id: number | null,
    items: any[],
    totalItems: number,
    totalPrice: number,
  }>({
    currency: "EUR", //default
    discounts: [],
    id: null,
    items: [],
    totalItems: 0,
    totalPrice: 0,
  });

  const availablePaymentMethods = ref<any[]>([])
  const availableShippingMethods = ref<any[]>([])

  const fetchCart = async () => {
    getCart().then(res => {
      cart.currency = res.cart.currency
      cart.id = res.cart.id
      cart.discounts = res.cart.discounts
      cart.totalPrice = res.cart.total_price
      cart.totalItems = res.cart.total_items
      cart.items = res.cart.cart_items

      availablePaymentMethods.value = res.available_payment_methods
      availableShippingMethods.value = res.available_shipping_methods
    })
  }

  /*
    Cart Item Detail
   */

  const cartItemDetail = reactive<{
    item: CartItemResponse | null;
    loading: boolean;
    error: any | null;
  }>({
    item: null,
    loading: false,
    error: null
  })
  const getCartItemDetail = async (id: number) => {
    cartItemDetail.item = null
    cartItemDetail.loading = true
    cartItemDetail.error = null

    return fetchCartItem(id).then(res => {
      cartItemDetail.item = res
    }).catch(err => {
      cartItemDetail.error = err
    }).finally(() => {
      cartItemDetail.loading = false
    })
  }

  const saveCartItemDetail = async () => {
    if (!cartItemDetail.item) return Promise.reject('[Cart store] saveCartItemDetail() failed - missing cartItemDetail.item');


  }

  return { cart, availablePaymentMethods, availableShippingMethods, cartItemDetail, fetchCart, getCartItemDetail }
})
